import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import ServicesSection from "./components/ServicesSection";
import PhilosophySection from "./components/PhilosophySection";
import CasesSection from "./components/CasesSection";
import ProcessSection from "./components/ProcessSection";
import NotesSection from "./components/NotesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <ProblemSection />
      <ServicesSection />
      <PhilosophySection />
      <CasesSection />
      <ProcessSection />
      <NotesSection />
      <FAQSection />
      <CTASection />
    </>
  );
}